import React from 'react'

const Placement = () => {
  return (
    <>
      <section>
        <h1>Placement</h1>
      </section> 
    </>
  )
}

export default Placement
